import routes from '@gik/core/routes';
import bemBlock from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { translationKeys as appTranslationKeys } from '@gik/i18n/en/app';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import { Button } from '@gik/ui/Button';
import { Container } from '@gik/ui/Container';
import { SvgIcon } from '@gik/ui/SvgIcon/SvgIcon';
import ArrowLeftIcon from '@heroicons/react/outline/ArrowLeftIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const SamplePageBannerBlockName = 'sample-page-banner';

export type SamplePageBannerProps = {
  className?: string;
};

function SamplePageBannerComp({ className }: SamplePageBannerProps): React.ReactElement {
  const bem = bemBlock(SamplePageBannerBlockName);
  const { t } = useTranslation();

  return (
    <div className={bem(null, null, className)}>
      <Container className={bem('container')}>
        <Button type={'a'} href={routes.tipsAndSamplePages} variant="white" size="sm" circle>
          <SvgIcon Icon={ArrowLeftIcon} size="sm" />
        </Button>
        <main>
          <span className={bem('title')}>{t(translationKeys.SamplePageTitle).toString()}</span>
          <Button type={'a'} href={routes.create()} variant="white" pill size="sm" className="gik-hidden-sm">
            {t(appTranslationKeys.createPage).toString()}
          </Button>
        </main>
      </Container>
    </div>
  );
}

export const SamplePageBanner = withComponentErrorBoundary(SamplePageBannerComp);
